<template>
  <div class="relative flex h-10 items-center rounded-md shadow-sm">
    <button
      @click="toggleVisualization"
      type="button"
      :class="
        !table
          ? 'border-ontick-steel-300 bg-ontick-steel-100 text-ontick-blue-600 dark:border-ontick-steel-500 dark:bg-ontick-steel-500'
          : 'border-ontick-steel-300 bg-gray-50 text-gray-500 dark:border-ontick-steel-600 dark:bg-ontick-steel-700'
      "
      class="focus:outline-none relative inline-flex min-h-full items-center rounded-l-lg border px-2 py-2 text-sm font-medium"
    >
      <i v-html="showSpinner && table ? $icons.loading : $icons.card_sm"></i>
    </button>
    <button
      @click="toggleVisualization"
      type="button"
      :class="
        table
          ? 'border-ontick-steel-300 bg-ontick-steel-100 text-ontick-blue-600 dark:border-ontick-steel-500 dark:bg-ontick-steel-500'
          : 'border-ontick-steel-300 bg-gray-50 text-gray-500 dark:border-ontick-steel-600 dark:bg-ontick-steel-700'
      "
      class="focus:outline-none relative -ml-px inline-flex min-h-full items-center rounded-r-lg border px-2 py-2 text-sm font-medium"
    >
      <i v-html="showSpinner && !table ? $icons.loading : $icons.menu_sm"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Boolean,
    },
    showSpinner: {
      type: Boolean,
    },
  },

  methods: {
    toggleVisualization() {
      this.$emit("toggle-visualization");
    },
  },
};
</script>

<style></style>
